import { Tab } from "@mui/material";
import { FilterTabs } from "@zfp-akademie-a-s/zfp-design";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { SortOrder } from "./utils/buildTimelineItems";

const Timeline = Resources.AnalysisDetail.Goals.Timeline;

const SORT_OPTIONS = [
  { order: "asc", label: Timeline.SortAsc },
  { order: "desc", label: Timeline.SortDesc },
] as const;

type Props = {
  value: SortOrder;
  onChange: (order: SortOrder) => void;
};

export const GoalsSortToggle = ({ value, onChange }: Props) => {
  const { t } = useResource();

  return (
    <FilterTabs
      value={value}
      onChange={(_, order: SortOrder) => onChange(order)}
      aria-label={t(Timeline.SortOrder)}
      sx={{ alignSelf: "flex-start" }}
    >
      {SORT_OPTIONS.map(({ order, label }) => (
        <Tab key={order} value={order} label={t(label)} />
      ))}
    </FilterTabs>
  );
};
